module.exports = __webpack_public_path__ + "static/media/shops.a4819d53.svg";